import axios from 'axios'

const INITIAL_CONFIG = {
    title: '果壳搜索',
    desc: '输入关键词，科普内容立即呈现',
    // link: window.location.href,
    link: `${window.location.origin}`,
    imgUrl: 'https://qunluo-static.guokr.com/FqTBmW0aEYtkYtpmzO-RJWBuyOAg'
}

export const weixinConfig = (config) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (!config) {
                const {data} = await axios.get(`/peanut/v1/weixin/config?url=${encodeURIComponent(window.location.href)}`)
                wx.ready(function (res) {
                    updateWeixinShareConfig()
                })
                wx.config({
                    ...data,
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
                })
                resolve(data)
            }
        } catch(error) {
            reject(error)
        }
    })
}

export const updateWeixinShareConfig = (config = {}) => {
    wx.updateAppMessageShareData({
        ...INITIAL_CONFIG,
        ...config
    })
    wx.updateTimelineShareData({
        ...INITIAL_CONFIG,
        ...config
    })
}



// WEBPACK FOOTER //
// ./src/methods/share.js